import { Keyboard } from 'lucide-react';
import { Popover, PopoverTrigger, PopoverContent } from '@/components/ui/popover';

interface ShortcutReferenceProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

// The only live keyboard shortcuts in the finance area are the triage-modal
// keys (see `useFinanceKeyboardShortcuts`, `scope: 'triage'`). The former
// `list` scope was deleted along with its keymap, so advertising its J/K nav +
// C/L/E/D classify keys here lied to users. This reference now mirrors the
// triage keymap exactly.
const SHORTCUTS = [
  { section: 'Classify' as const, items: [
    { key: 'D', label: 'Contribution' },
    { key: 'E', label: 'Expense' },
    { key: 'X', label: 'Exclude' },
  ]},
  { section: 'Actions' as const, items: [
    { key: 'Enter', label: 'Confirm' },
    { key: 'R', label: 'Request donor info' },
    { key: 'P', label: 'Pick parent' },
    { key: 'S', label: 'Skip' },
    { key: 'Esc', label: 'Close' },
  ]},
];

export function ShortcutReference({ open, onOpenChange }: ShortcutReferenceProps) {
  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label="Keyboard shortcuts"
          className="flex items-center gap-1 rounded-md border px-2 py-1 text-xs text-muted-foreground hover:bg-accent"
        >
          <Keyboard className="h-3 w-3" />
          <span>?</span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-64 p-3" align="end">
        <div className="space-y-3">
          <h3 className="text-sm font-semibold">Keyboard shortcuts</h3>
          {SHORTCUTS.map((group) => (
            <div key={group.section} className="space-y-1">
              <p className="text-xs font-medium text-muted-foreground">{group.section}</p>
              {group.items.map((shortcut) => (
                <div key={shortcut.key} className="flex items-center justify-between">
                  <span className="text-xs">{shortcut.label}</span>
                  <kbd className="rounded bg-muted px-1.5 py-0.5 text-xs font-mono">
                    {shortcut.key}
                  </kbd>
                </div>
              ))}
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
